import { lazy } from "react";

const routes = [
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/fulfillment_center",
    element: lazy(() => import("../pages/Fulfillmentcenter")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/fulfillmentcenter/add",
    element: lazy(() => import("../pages/Fulfillmentcenter/create")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/fulfillmentcenter/edit/:id",
    element: lazy(() => import("../pages/Fulfillmentcenter/create")),
  },
];

export default routes;
